const base = {
	black: "#232323",
	white: "#ffffff",
	red: "#B30838",
	redDark: "#820024",
	beigeLight: "#f1edea",
	beigeDark: "#e9e4de",
};



const Colors = {
	base
};

export default Colors;
